import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmxWebComponentsModule } from '@cmx-web-components/angular';

import { AlertsOutputComponent } from './alerts/alerts-output.component';
import { LoginComponent } from './login/login.component';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
  declarations: [AlertsOutputComponent, LoaderComponent, LoginComponent],
  imports: [CommonModule, TranslateModule.forChild(), FormsModule, ReactiveFormsModule, CmxWebComponentsModule],
  exports: [AlertsOutputComponent, LoaderComponent, LoginComponent],
})
export class CmxClientComponentsModule {}
